
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiHeavySleetColour as ObiHeavySleetColourElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-heavy-sleet-colour.js';
 
 
 

 
 export const ObiHeavySleetColour = createComponent({
   react: React,
   tagName: 'obi-heavy-sleet-colour',
   elementClass: ObiHeavySleetColourElement,
   events: {
     
   }
  });
 
 